










import Vue from 'vue';

import ResetPassword from '@/web/components/signup/ResetPassword.vue';

export default Vue.extend({
  name: 'AdminResetPassword',
  components: {
    ResetPassword,
  },
});
